import { Component, OnInit } from '@angular/core';
import { GtmService } from '@core/services/gtm/gtm.service';
import { GTM_OVERVIEW_EVENTS } from '@core/services/gtm/gtm.events';

@Component({
	selector: 'app-to-top-btn',
	templateUrl: './to-top-btn.component.html',
	styleUrls: ['./to-top-btn.component.scss'],
})
export class ToTopBtnComponent implements OnInit {
	isActive = false;
	scrollPosition = 0;

	constructor(private gtm: GtmService) {}

	ngOnInit(): void {
		window.addEventListener('scroll', () => {
			this.scrollPosition = window.scrollY;
			this.isActive = this.scrollPosition > 150;
		});
	}

	scrollToTop(): void {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
		this.gtm.pushEvent(GTM_OVERVIEW_EVENTS.BACK_TO_TOP);
	}
}
